// 自定义hook，只有逻辑，没有UI
import React, {useEffect, useReducer} from 'react';
import {axios_} from "../../../tools/axios_";
import { Utils } from '../../../tools/utils';
import queue from './bapingQueue.json';

// 霸屏的接口
export const useBaPingAPI = props => {
  // 初始化state
  const getInitState = () => {
    return queue.reduce((json = {},item = '') => {
      json[item] = false
      return json;
    },{})
  }

  // reducer
  const reducer = (state = {},action = {}) => {
    action = actions(action);
    switch (action.type) {
      case 'reset':
        return getInitState();
      default:
        return {
          ...state,
          [action.type]:action.visible
        };
    }
  };
  // 获取action
  const actions = action => {
    const key = Object.keys(action)[0];
    return {
      type:key,
      visible:action[key]
    }
  };
  const [state, dispatch] =useReducer(reducer,getInitState());

  // 初始化执行,接口必须一个个串联执行
  useEffect(_=>{
    getSettlementCount()
      .then(getActivityState)
      .then(getCommissionGuide)
      .then(getOrguserGuide).catch(()=>{});
  },[]);

  /** 结算霸屏：获取结算单状态，当有结算单等待商户确认时, 商户一登录就会提示一个弹窗  */
  const getSettlementCount = () => {
    return new Promise((resolve,reject) =>{
      axios_({
        url: 'unConfirmSettlementCount',
        method: 'get',
        headers: {
          'access-token': props.token
        }
      }).then(res => {
        if (res.data.status === 200 && res.data.data > 0) {
          // 结算霸屏
          dispatch({jiesuanVisible: true});
        }
        resolve();
      }).catch(e => {
        reject(e);
      })
    });
  };
  /** 活动霸屏  */
  const getActivityState = () => {
    return new Promise((resolve,reject) =>{
      axios_({
        url: '/api/commission/activityRule/getPcPromptList',
        method: 'get',
        headers: {
          'access-token': props.token
        }
      }).then(res => {
        if (res.data.status === 200) {
          // 活动霸屏
          dispatch({ activityVisible: res.data.data && res.data.data.length > 0 });
          sessionStorage.setItem('session_activity_list',JSON.stringify(res.data.data || []))
        }
        resolve();
      }).catch(e => {
        reject(e);
      });
    });
  };
  /**
   * 霸屏-推广费升级弹窗
   */
  const getCommissionGuide = () => {
    return new Promise((resolve,reject) =>{
      axios_({
        url: `/api/cls/welcome/new/commisiomGuide`,
        method: 'get',
        headers: {
          'access-token': props.token
        },
        params: { userId: Utils.getUserId() }
      }).then(res => {
        if (res.data.status === 200) {
          dispatch({ entirelyUpgrade:  !!res.data.data});// 推广费弹窗-升级
        }
        resolve();
      }).catch(e => {
        reject(e);
      });
    });
  }
  /** 霸屏：新商户第一次打开，升级框  */
  const getOrguserGuide = () => {
    return new Promise((resolve,reject) =>{
      axios_({
        url: '/api/admin/user/getExtends',
        method: 'get',
        headers: {
          'access-token': props.token
        }
      }).then(res => {
        if (res.data.status === 200) {
          dispatch({privacyVisible:res.data.data.USER_CLAUSE_IS_AGREE == '0'}); //注册协议霸屏
          dispatch({isApiEnd: true}); // 最后一个接口结束
        }
        resolve();
      }).catch(e => {
        reject(e);
      });
    });
  };

  return [state,dispatch];
};

